import { useInfiniteQuery } from '@tanstack/react-query'
import { supabase } from '../api'

const getPosts = async (
  feed: any,
  ranking: string | null,
  limit: number,
  category: string,
  pageParam?: string | undefined,
  queryKey?: any,
  client?: any,
  id?: string,
) => {
  if (!feed?.get) {
    throw new Error('Invalid feed object')
  }
  const { data: userData } = await supabase.auth.getSession()
  let feedData

  if (category === 'user_activity') {
    feedData = await client.feed('user_activity', userData?.session?.user?.id).get({
      limit,
      id_lt: id || pageParam || '',
      ranking: ranking || undefined,
      enrich: true,
      reactions: {
        own: true,
        counts: true,
        recent: false,
      },
    });
  } else if (category === 'following') {
    feedData = await client.feed('user', userData?.session?.user?.id).get({
      limit,
      id_lt: id || pageParam || '', // score_lt
      ranking: ranking || undefined,
      enrich: true,
      reactions: {
        own: true,
        counts: true,
        recent: false,
      },
    });
  } else {
    feedData = await feed.get({
      category,
      limit,
      id_lte: id || (pageParam || ''), // score_lt
      ranking: ranking || undefined,
      enrich: true,
      reactions: {
        own: true,
        counts: true,
        recent: false,
      },
    });
  }
  // return feedData
  const ids = feedData.results.map((v: any) => v.foreign_id).filter((v) => v)
  const { data, error } = await supabase
    .from('posts')
    .select(`
      *,
      category:categories(*),
      profile:user_profiles (id, username),
      assetPrices:posts_assets (price_time_posting, asset_id),
      assets:assets!posts_assets (
        *,
        category:categories(*)
      )`)
    .in('id', ids);

  if (error) {
    throw new Error(error.message)
  }
  feedData.results = feedData.results.map((v: any) => {
    const d = data.find((item: any) => (`${item.id}` === v.foreign_id))
    return {
      ...v,
      data: d ? {
        ...d,
        assets: (d?.assets || []).map((a) => ({
          ...a,
          postingPrice: d?.assetPrices
            .find((ap) => (ap.asset_id === a.id))?.price_time_posting || 0,
        })),
      } : d,
      queryKey,
    }
  }).filter((v: any) => v.data)

  return feedData
}

export default function usePosts(feed: any, ranking: string | null = '', limit: number = 5, category: string = '', client: any = null, id?: string) {
  const queryKey = ['posts', feed?.id, ranking, limit, category]
  return useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) => getPosts(
      feed,
      ranking,
      limit,
      category,
      pageParam,
      queryKey,
      client,
      id,
    ),
    enabled: Boolean(feed),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
    getPreviousPageParam: () => undefined,
    getNextPageParam: (lastPage: any) => (
      lastPage.next
        ? lastPage.results[lastPage.results.length - 1]?.id
        : undefined
    ),
  })
}
